const userAgent = navigator.userAgent.toLowerCase();
export default userAgent.indexOf('msie') !== -1 || userAgent.indexOf('trident') !== -1 || userAgent.indexOf('edge') !== -1;



// WEBPACK FOOTER //
// ./src/common/isMsBrowser.js